import { isValidCpfCnpj, normalizeCpfCnpj } from './documentValidation';

export { isValidCpfCnpj };

export function formatCnpj(cnpj: string | null | undefined): string {
  if (!cnpj) return '';
  const clean = normalizeCpfCnpj(cnpj);
  if (clean.length !== 14) return cnpj;
  return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8, 12)}-${clean.slice(12, 14)}`;
}

function formatCpf(cpf: string | null | undefined): string {
  if (!cpf) return '';
  const digits = cpf.replace(/\D/g, '');
  if (digits.length !== 11) return cpf;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`;
}

export function formatCpfCnpj(value: string | null | undefined): string {
  if (!value) return '';
  const clean = normalizeCpfCnpj(value);
  if (clean.length === 11) return formatCpf(value);
  if (clean.length === 14) return formatCnpj(value);
  return value;
}

/**
 * Máscara de CNPJ idempotente: aceita valor cru ou já mascarado, trunca em 14
 * caracteres e preserva os alfanuméricos do CNPJ novo.
 */
export function applyCnpjMask(value: string): string {
  const clean = normalizeCpfCnpj(value).slice(0, 14);
  let masked = clean.slice(0, 2);
  if (clean.length > 2) masked += `.${clean.slice(2, 5)}`;
  if (clean.length > 5) masked += `.${clean.slice(5, 8)}`;
  if (clean.length > 8) masked += `/${clean.slice(8, 12)}`;
  if (clean.length > 12) masked += `-${clean.slice(12, 14)}`;
  return masked;
}

/**
 * Reduz o documento aos 4 caracteres finais para telemetria e log, conforme a
 * regra de PII do repositório — nunca registrar CPF/CNPJ completo.
 */
export function maskCnpjParaLog(value: string): string {
  const clean = normalizeCpfCnpj(value);
  return clean.length < 4 ? '***' : `***${clean.slice(-4)}`;
}

export function applyCpfCnpjMask(value: string): string {
  const clean = normalizeCpfCnpj(value).slice(0, 14);
  const isCnpj = clean.length > 11 || /[A-Z]/.test(clean);

  if (!isCnpj) {
    return clean
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }

  return applyCnpjMask(clean);
}
